// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__5dAX+","title":"HeroContent_title__JBY6U","description":"HeroContent_description__KuGO-","control":"HeroContent_control__RwkJF"};